import { render } from "./setup-options.vue?vue&type=template&id=29e69947&scoped=true"
import script from "./setup-options.vue?vue&type=script&lang=js"
export * from "./setup-options.vue?vue&type=script&lang=js"

import "@/css/bootstrap.min.css?vue&type=style&index=0&id=29e69947&scoped=true&lang=css"
import "./setup-options.vue?vue&type=style&index=1&id=29e69947&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e69947"]])

export default __exports__